<div class="pagination" *ngIf="total > 0">
  <button
    (click)="prevPage()"
    nbButton
    ghost
    size="small"
    [disabled]="currentPage === 1"
  >
    <nb-icon icon="chevron-right-outline"></nb-icon>
  </button>

  <ng-container *ngFor="let p of pages">
    <span *ngIf="p === 'blank'" class="pagination-blank">...</span>
    <button
      *ngIf="p !== 'blank'"
      nbButton
      size="small"
      ghost="currentPage !== p"
      [status]="currentPage === p ? 'success' : 'basic'"
      [disabled]="currentPage === p"
      (click)="handleChangePage(p)"
    >
      {{ p }}
    </button>
  </ng-container>
  <button
    (click)="nextPage()"
    nbButton
    ghost
    size="small"
    [disabled]="currentPage === totalPages"
  >
    <nb-icon icon="chevron-left-outline"></nb-icon>
  </button>
</div>
